import { StdResponse, bimAxios } from "@/config/axios";
import { GlobalDataBox } from "@/commons/interface/lib-device/global-data-box";


export function getGlobalDataBoxDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/global-data-boxes/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createGlobalDataBox(data: GlobalDataBox, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/global-data-boxes`, data, {
        params: {
            ...params,
        }
    })
}

export function updateGlobalDataBox(id: number, data: GlobalDataBox, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/global-data-boxes/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteGlobalDataBox(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/global-data-boxes/${id}`, {
        params: {
            ...params,
        }
    })
}

export function getGlobalDataBoxes(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/global-data-boxes`, {
        params: {
            ...params,
        }
    })
}